import r from "../managers/braze-instance.js";
import vt from "./utils/push-utils.js";
export function isPushBlocked() {
  if (r.rr()) return vt.isPushBlocked();
}
